export default class DiscountsRepository {
  constructor({ discountsService }) {
    this.discountsService = discountsService;
  }

  getDiscounts(criteria) {
    return this.discountsService.getDiscounts(criteria);
  }

  getAllDiscounts() {
    return this.discountsService.getAllDiscounts();
  }

  createDiscount(payload) {
    return this.discountsService.createDiscount(payload);
  }

  updateDiscount(id, payload) {
    return this.discountsService.updateDiscount(id, payload);
  }

  removeDiscount(id) {
    return this.discountsService.removeDiscount(id);
  }
}
